import MessageUs from "components/MessageUs";
import PageHeader from "components/PageHeader";

import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";

interface ContactUsProps {}

const ContactUs: React.FC<ContactUsProps> = ({}) => {
  const dispatch = useDispatch();
  // const metaData = useMetaData();
  useEffect(() => {
    dispatch(setBreadcrumbTitle("Контакти"));

    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, []);

  return (
    <ContactUsContainer>
      <PageHeader title="Контакти" subtitle="Свържете се с нас" />
      {/* message */}
      <MessageUs />
      {/* visit us */}
      {/* <VisitUs /> */}
    </ContactUsContainer>
  );
};

const ContactUsContainer = styled.div``;

export default ContactUs;
